import AllocationRoleApi from './am-allocation-role-api';
export default AllocationRoleApi;
